
<template>
<div>
  <div
      class="d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"
    >
      <div>
                <router-link :to="{ path: '/races'}">
          <button type="submit" class="btn btn-warning btn-sm px-3 mr-3">Yarışlar</button>
        </router-link>
        <router-link :to="{ path: '/seasons'}">
          <button type="submit" class="btn btn-info active btn-sm px-3 mr-3">Sezonlar</button>
        </router-link>

        <router-link :to="{ path: '/members'}">
          <button type="submit" class="btn btn-danger btn-sm px-3 mr-3">Üyeler</button>
        </router-link>

      </div>
      <span></span>
    </div>
  <card>
    <div v-if="!err">

    <h4 slot="header" class="card-title d-md-flex justify-content-between">
      <span>Branşlar</span>
      <div>
        <router-link v-b-tooltip title="Yeni Branş Ekle" :to="{ path: 'seasons/add-edit/'}" class="btn btn-primary" tag="li"><i class="fas fa-plus"></i> Yeni Branş</router-link>
      </div>
    </h4>
    <div class="row">
      <div class="col-12">
        <h6 class="ml-3">Branşlar</h6>
        <b-tabs pills card vertical>
          <b-tab v-bind:title="category.name" v-for="(category, index) in categories" :key="index">
            <div class="row">
              <div class="col-12 card">
                <div class="card-body">
                  <h5 class="d-md-flex justify-content-between">
                    <span>{{category.name}}</span>
                    <div>
                      <router-link v-b-tooltip title="Düzenle" :to="{ path: 'seasons/add-edit/'+category.id+'/0'}" class="btn btn-primary btn-fill btn-xs" tag="li"><i class="fas fa-edit"></i></router-link>
                      <button v-on:click="remove(category.id,'categories')"  v-b-tooltip title="Sil" class="btn btn-danger btn-xs"><i class="fas fa-eye-slash"></i></button>
                      <a href="javascript:void(0)" class="btn btn-xs btn-danger btn-fill" v-if="category.is_active" v-on:click="deactivate(category.id,'categories')" v-b-tooltip title="Yayından Kaldır" id="remove-item.id"><i class="fas fa-eye-slash"></i></a>
                      <a href="javascript:void(0)" class="btn btn-xs btn-success btn-fill" v-if="!category.is_active" v-b-tooltip v-on:click="activate(category.id,'categories')" title="Yayına al" id="activate-item.id"><i class="fas fa-eye"></i></a>
                    </div>
                  </h5>
                  <div class="w-100 card card-body">
                    <h6>Sezonlar</h6>
                    <div class="card mb-2" v-for="(subCategory, i) in categories[index].sub_categories" :key=i>
                      <div class="card-body row">
                        <div class="col-9">{{subCategory.name}}</div>
                        <div class="col-3 d-flex justify-content-end">
                          <div>
                            <router-link v-b-tooltip title="Düzenle" :to="{ path: 'category/add-edit/'+subCategory.id+'/1'}" class="btn btn-primary btn-fill btn-xs" tag="li"><i class="fas fa-edit"></i></router-link> 
                             <button v-on:click="remove(subCategory.id,'SubCategories')"  v-b-tooltip title="Sil" class="btn btn-danger btn-xs"><i class="fas fa-eye-slash"></i></button>
                            <a href="javascript:void(0)" class="btn btn-xs btn-danger btn-fill" v-if="subCategory.is_active" v-on:click="deactivate(subCategory.id,'sub-categories')" v-b-tooltip title="Yayından Kaldır" id="deactivate-item.id"><i class="fas fa-eye-slash"></i></a> 
                            <a href="javascript:void(0)" class="btn btn-xs btn-success btn-fill" v-if="!subCategory.is_active" v-b-tooltip v-on:click="activate(subCategory.id,'sub-categories')" title="Yayına al" id="activate-item.id"><i class="fas fa-eye"></i></a>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>

    </div>
<div v-if="err">
  {{err}}
</div>
  </card>
</div>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'

  export default {
    data: function () {
      return {
        category:{
          is_active:0
        },
        categories: null,
        total: 0,
        limit: localStorage.getItem('filterLimit'),
        page: 1,
        pageCount: null,
        navigation: true,
        type: 'all',
        viewCounts: [],
        err:null
      }
    },
    components: {
      Card
    },

    methods: {
      deactivate: function(id,type){
        this.toggleLoader()
        this.category.is_active = 0
        this.$http.post('/api/' + type + '/edit/' + id, this.category).then(
          response => {
            this.notifier('top', 'right', 'warning', 'Sezon Yayından Kaldırıldı')
            this.getPosts()
            this.toggleLoader()
          },
          e => {
  this.toggleLoader()
                                                        if(!e.body.Error){
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{
              this.notifier('top', 'right', 'danger', e.body.Error)

            }
          })
      },
      remove: function(id,type){
        this.toggleLoader()
        this.$http.post('/api/' + type + '/delete/' + id, this.category).then(
          response => {
            this.notifier('top', 'right', 'warning', 'Sezon Silindi')
            this.getPosts()
            this.toggleLoader()
          },
          e => {
            this.toggleLoader()
                                                        if(!e.body.Error){
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{
              this.notifier('top', 'right', 'danger', e.body.Error)

            }
          })
      },
      activate: function(id,type){
        this.toggleLoader()
        this.category.is_active = 1
        this.$http.post('/api/' + type + '/edit/' + id, this.category).then(
          response => {
            this.notifier('top', 'right', 'success', 'Sezon Yayına Alındı')
            this.getPosts()
            this.toggleLoader()
          },
          e => {
  this.toggleLoader()
                                                        if(!e.body.Error){
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{
              this.notifier('top', 'right', 'danger', e.body.Error)

            }
          })
      },

      getPosts: function () {
        this.toggleLoader()
        var url = '/api/categories/all-with-joins-seasons/'
        this.$http
        .get(url)
        .then(
          response => {
            this.categories = response.body
            this.toggleLoader()
          },
          er => {
                    this.toggleLoader()

             if(!er.body.Error){
             this.notifier(
              'top',
              'right',
              'danger',
              'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
            }else{
              this.err = er.body.Error;
            this.notifier(
              'top',
              'right',
              'danger',
              er.body.Error
              )
            }
          }
          )
      },
      toggleNavigation () {
        var button = event.target
        if (this.navigation) {
          button.innerHTML = '<i class="fas fa-caret-down"></i>'
          this.navigation = false
        } else {
          button.innerHTML = '<i class="fas fa-caret-up"></i>'
          this.navigation = true
        }
      },
      toggleNewPostPanel (event) {
        event.stopPropagation()
        if (document.getElementById('new-post').classList.contains('d-none')) {
          document.getElementById('new-post').classList.remove('d-none')
        } else {
          document.getElementById('new-post').classList.add('d-none')
        }
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.getPosts()
      })
    }
  }
</script>
<style>
.nav .nav-item .nav-link:hover, .nav .nav-item .nav-link:focus{
  background-color: #007bff !important;
}
.nav-pills:focus{
  outline: none;
}
.nav-pills a{
  color:#000;
}

.nav .nav-item .nav-link:hover, .nav .nav-item .nav-link:focus{
  color:#fff;
}
.nav-item{
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/RaceCategoryModules/Main.vue